export default {
  get () : Record<string, any> {
    return {}
  },
  set (params : Record<string, any>) {
  }
}
